<template>
  <div>
    <div>Количество событий</div>
    <filter-range :range="range" v-model="input.number"/>

    <div class="mt-3">Даты событий</div>
    <filter-range-date v-model="input.date"/>
  </div>
</template>

<script>
  import { omitBy, isEmpty, isEqual } from 'lodash'

  export default {
    props: {
      range: {type: Object},
      value: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data () {
      return {
        input: {
          number: this.value.number || {},
          date: this.value.date || {},
        },
      }
    },
    computed: {
      preparedInput () {
        return omitBy(this.input, isEmpty)
      },
    },
    watch: {
      value (input) {
        this.input = {
          number: input.number || {},
          date: input.date || {},
        }

      },
      preparedInput: {
        handler (newVal, oldVal) {
          if (!isEqual(newVal, oldVal)) {
            this.$emit('input', this.preparedInput)
          }
        },
        deep: true,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-event.vue